<template>
  <div>
    <a-form :form="form">
      <a-row :gutter="[16,16]">
        <a-col :span="24">
          <a-page-header
            :title="this.record.name"
            sub-title="用户信息编辑"
            @back="handleGoBack" >
          </a-page-header>
        </a-col>
        <a-col :span="12">
          <a-form-item label="姓名" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input
              disabled
              v-decorator="['name', {rules: [{required: true, message: '请输入'}, {min:2, max:10, message: '输入不符合长度限制'}]}]"
              placeholder="用户真实姓名"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="邮箱" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['email', {rules: [{required: false, message: '请输入'}, {max:48, message: '输入不符合长度限制'}]}]" placeholder="邮箱"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['cell_phone1', {rules: [{required: false, message: '请输入'}, {max:20, message: '输入不符合长度限制'}]}]" placeholder="手机号"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="备用手机号" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['cell_phone2', {rules: [{required: false, message: '请输入'}, {max:20, message: '输入不符合长度限制'}]}]" placeholder="备用手机号"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="办公地点" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-textarea v-decorator="['office_location', {rules: [{required: false, message: '请输入'}, {max:255, message: '输入不符合长度限制'}]}]" placeholder="办公地点" :rows="1"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="OA Code" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['oa_code', {rules: [{required: false, message: '请输入'}, {max:32, message: '输入不符合长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
        </a-col>
        <a-col :span="12">
          <a-form-item label="金蝶编码" :labelCol="labelCol" :wrapperCol="wrapperCol">
            <a-input v-decorator="['jd_code', {rules: [{required: false, message: '请输入'}, {max:64, message: '输入不符合长度限制'}]}]" placeholder="请输入"/>
          </a-form-item>
        </a-col>
      </a-row>
      <a-form-item
        v-bind="buttonCol"
      >
        <a-row>
          <a-col :offset="4" span="10">
            <a-button type="primary" html-type="submit" @click="handleSubmit">提交</a-button>
          </a-col>
          <a-col span="6">
            <a-button @click="handleGoBack">返回</a-button>
          </a-col>
        </a-row>
      </a-form-item>
    </a-form>
  </div>
</template>

<script>
import pick from 'lodash.pick'
import { tradeUserUpdate } from '@/api/trade_user'

export default {
  name: 'TableEdit',
  props: {
    record: {
      type: [Object, String],
      default: ''
    }
  },
  data () {
    return {
      labelCol: {
        xs: { span: 6 },
        sm: { span: 6 }
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 }
      },
      labelCol2: {
        xs: { span: 6 },
        sm: { span: 3 }
      },
      wrapperCol2: {
        xs: { span: 24 },
        sm: { span: 20 }
      },
      buttonCol: {
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 12, offset: 5 }
        }
      },
      form: this.$form.createForm(this),
      id: 0
    }
  },
  mounted () {
    this.$nextTick(() => {
      this.loadEditInfo(this.record)
    })
  },
  methods: {
    handleGoBack () {
      this.$emit('onGoBack')
    },
    handleSubmit () {
      const { form: { validateFields } } = this
      validateFields((err, values) => {
        if (!err) {
          tradeUserUpdate(values, this.record.id)
            .then((res) => {
              if (res.code === 1000) {
                this.handleGoBack()
              }
            })
        }
      })
    },
    loadEditInfo (data) {
      const { form } = this
      new Promise((resolve) => {
        setTimeout(resolve, 0)
      }).then(() => {
        const formData = pick(data, ['id', 'name', 'email', 'cell_phone1', 'cell_phone2', 'office_location', 'oa_code', 'jd_code'])
        this.id = formData.id
        form.setFieldsValue(formData)
      })
    }
  }
}
</script>
